import React from 'react';
import './App.css';

import {useState, useEffect} from "react";
import { collection, getDocs } from "@firebase/firestore";
import {db} from './firebase-config';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Footer from './components/Footer';
import Home from './components/pages/home';
import Signup from './components/pages/signup';
import Login from './components/pages/login';
import Account from './components/pages/account';
import Browse from './components/pages/browse';

import { AuthContextProvider } from './context/AuthContext';


function App() {
  const [userTest, setUserTest] = useState([]);
  const usersCollection = collection(db, "user");
  useEffect(() => {
    const getUsers = async () => {
      const testData = await getDocs(usersCollection);
      setUserTest(testData.docs.map((doc) => ({...doc.data(), id: doc.id})))
    };
  getUsers();
  
  }, []);
  
    // return <div className="App"> {userTest.map((user) => {
    //   return (
    //   <div> 
    //     {" "}
    //     <h1>Name: {user.name} </h1>
    //   </div>)
    // })} </div>;

    return (
      <AuthContextProvider>
        <Router>
          <Routes>
            <Route exact path="/" element={<Home />}/>
            <Route exact path="/signup" element={<Signup />}/>
            <Route exact path="/login" element={<Login />}/>
            <Route exact path="/account" element={<Account />}/>
            <Route exact path="/browse" element={<Browse />}/>
          </Routes>
          <Footer />
        </Router>
      </AuthContextProvider>
    )
 }

export default App;
